import Vue from 'vue'
import Vuetify from '@/plugins/vuetify'

import ViewSettingsDefaults from '@/components/settings/defaults'
import {init_state} from '@/store/state'
import {ControlTypes, LocalStore, LocalStoreKeys} from '@/utils/vars'

export default {
  add_app(state, app_data) {
    Vue.set(state.apps, app_data.id, app_data)
  },
  clear_app(state) {
    Vue.set(state, 'components', {})
    Vue.set(state, 'connection', {app_id: null, connected: false})
    Vue.set(state, 'saved_app_layout', {})
    Vue.set(state, 'saved_app_settings', {})
  },
  clear_user(state) {
    Vue.set(state, 'user', null)
  },
  clear_log(state) {
    Vue.set(state, 'log_messages', [])
  },
  clear_notification(state) {
    state.notification.text = ''
    state.notification.level = null
  },
  delete_app(state, id) {
    Vue.delete(state.apps, id)
  },
  reset_state(state) {
    Object.entries(init_state).forEach(([k, v]) => {
      Vue.set(state, k, v)
    })
  },
  set_api_key(state, new_api_key) {
    Vue.set(state, 'api_key', new_api_key)
  },
  set_app_id(state, app_id) {
    Vue.set(state, 'app_id', app_id)
    LocalStore.setItem(LocalStoreKeys.AppId, app_id)
  },
  set_app_size(state, value) {
    Vue.set(state, 'app_size', value)
  },
  set_apps(state, apps) {
    Vue.set(state, 'apps', apps)
  },
  set_component_highlight(state, {id, highlight}) {
    const component = state.components[id]
    if(component) {
      Vue.set(component, 'highlight', highlight)
    }
  },
  set_component_setting(state, data) {
    const component = state.components[data.component_id]
    if(component && data.setting_id && data.value !== undefined) {
      const setting = component.settings[data.setting_id]
      Vue.set(setting, 'value', data.value)
    }
  },
  set_connection(state, value) {
    Vue.set(state, 'connection', value)
  },
  set_dark_theme(state, is_dark) {
    state.is_dark = is_dark
    LocalStore.setItem(LocalStoreKeys.DarkTheme, is_dark)
    Vuetify.framework.theme.dark = is_dark
  },
  set_error(state, e) {
    state.error = e
  },
  set_loader_visibility(state, {component_id, visible}) {
    if(state.components[component_id]) {
      Vue.set(state.components[component_id], 'loading', visible)
    }
  },
  set_req_error(state, [op, value]) {
    Vue.set(state.req_errors, op, value)
  },
  set_req_state(state, [op, value]) {
    Vue.set(state.req_state, op, value)
  },
  set_namespace(state, ns) {
    Vue.set(state, 'namespace', ns)
    LocalStore.setItem(LocalStoreKeys.UserNamespace, ns)
  },
  set_pending_namespace(state, ns) {
    Vue.set(state, 'pending_namespace', ns)
  },
  set_saved_app_controls(state, controls) {
    const update = {...state.saved_app_controls, ...controls}
    Vue.set(state, 'saved_app_controls', update)
  },
  set_saved_app_layout(state, layout) {
    const update = {...state.saved_app_layout, ...layout}
    Vue.set(state, 'saved_app_layout', update)
  },
  set_saved_app_settings(state, settings) {
    const update = {...state.saved_app_settings, ...settings}
    Vue.set(state, 'saved_app_settings', update)
  },
  set_user(state, user_data) {
    Vue.set(state, 'user', user_data)
  },
  update_app(state, app) {
    Vue.set(state.apps, app.id, app)
  },
  update_component_frame(state, component_id) {
    if(state.components[component_id]) {
      const frame = state.components[component_id].frame + 1
      Vue.set(state.components[component_id], 'frame', frame)
    }
  },
  update_component_layout(state, layout) {
    if(state.components[layout.i]) {
      Vue.set(state.components[layout.i], 'layout', layout)
    }
  },
  update_component(state, comp) {
    const id = comp['id']
    const c = state.components[id]

    if(c) {
      const frame = c.frame + 1
      Vue.set(
        state.components,
        id, {...c, ...comp, frame})
    } else {
      const type = comp['type']
      if(id && type) {
        if(!ControlTypes.includes(type)) {
          // Create the default settings for the new component
          const settings = (ViewSettingsDefaults[type] || function() {})()

          // Restore any saved settings for the new component
          const saved_settings = state.saved_app_settings[id] || []
          Object.entries(saved_settings).forEach(([k, v]) => {
            if(settings && settings[k]) settings[k].value = v
          })

          Vue.set(state.components, id, {
            id,
            type,
            ...comp,
            settings,
            frame: 0,
            visible: true,
            highlight: false
          })
        }
      }
    }
  },
  update_notification(state, {text, level}) {
    state.notification.text = text || null
    state.notification.level = level || null
  },
  update_log(state, {message, level}) {
    Vue.set(state, 'log_messages', [...state.log_messages, {message, level}].slice(-1024))
  }
}
